import {ChangeDetectorRef, Component, EventEmitter, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ScorecardService} from "../../_services/scorecard.service";
import {ParameterService} from "../../_services/parameter.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {AdminService} from "../dashboard/services/admin.service";
import {isMoment} from "moment";

@Component({
    selector: 'admin-user-assessment-editor',
    templateUrl: './user-man-assessment-editor.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class UserManAssessmentEditorComponent extends BaseComponentDirective implements OnInit {
    public result = new EventEmitter();
    public form: FormGroup;
    public competitionLevels: any = {};
    user: any = null;
    scorecards: any[] = [];
    wideMatch: any[] = [];
    mode = 'new';
    assessment: any = {};
    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private scorecardService: ScorecardService,
        private parameterService: ParameterService,
        private adminService: AdminService,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            userId: [null, [Validators.required]],
            userName: [null, [Validators.required]],
            assessmentDate: [null, [Validators.required]],
            competitionLevel: [null, [Validators.required]],
            summary: [null, [Validators.required]]
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.competitionLevels = await this.parameterService.getParameterByName("COMPETITION_LEVEL");
        this.mode = this.activatedRoute.snapshot.params.mode;

        this.user = await this.adminService.getUserById(this.activatedRoute.snapshot.params.userId);

        await this.reset();
    }

    async reset(): Promise<void> {

        this.form.controls.userId.disable();
        this.form.controls.userName.disable();

        if(this.mode == 'edit') {

            this.assessment = await this.scorecardService.getByIdAndUserId(this.activatedRoute.snapshot.params.id, this.user.id);
            this.form.controls.assessmentDate.setValue(this.assessment.assessmentDate);
            this.form.controls.competitionLevel.setValue(this.assessment.competitionLevel);
            this.form.controls.summary.setValue(this.assessment.summary);
            this.scorecards = [...[]];
            this.wideMatch = [...[]];
            this.assessment.individualChallenges.forEach((x: any) => {
                this.scorecards.push({id:x.id, challengeName: x.challengeName, accuracy: x.accuracy, competency: x.competency, rankLevel: x.rankLevel})
            });

            this.assessment.wideMatches.forEach((x: any) => {
                this.wideMatch.push({id:x.id, challengeName: x.challengeName, averageAccuracy: x.averageAccuracy, averageCompetency: x.averageCompetency})
            })
        } else {
            this.form.reset();
            this.form.markAsPristine();
            this.form.markAsUntouched();
            this.cdr.detectChanges()

            this.scorecards = [];
            this.wideMatch = [];
        }

        this.form.controls.userName.setValue(this.user.fullName + ' - ' + this.user.email);
        this.form.controls.userId.setValue(this.user.id);
    }

    addScorecard() {
        this.scorecards.push({id:null, challengeName: '', accuracy: 0, competency: 0, rankLevel: ''})
    }

    deleteScorecard(scorecard: any, index: number) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Confirm Deletion of ${(scorecard.challengeName)? scorecard.challengeName: 'empty'}` ,
                subMessage: 'Are you sure want to delete this row of scorecard?',
                buttonOkLabel: 'Ok, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        })
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.scorecards.splice(index, 1);
            }
        })

    }

    deleteWideMatch(wideMatch: any, index: number) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Confirmation Deletion of ${(wideMatch.challengeName)? wideMatch.challengeName: 'empty'}`,
                subMessage: 'Are you sure want to delete this row of wide-match?',
                buttonOkLabel: 'Ok, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        })
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.wideMatch.splice(index, 1);
            }
        })

    }

    addWideMatch() {
        this.wideMatch.push({id: null, challengeName: '', averageAccuracy: 0, averageCompetency: 0});
    }

    resetForm() {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Confirmation Reset Form`,
                subMessage: 'Are you sure want to reset the form?',
                buttonOkLabel: 'Yes, Reset',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        })
        dialog.componentInstance.result.subscribe(async r => {
            if (r) {
                await this.reset();
                this.scorecards = [];
                this.wideMatch = [];
            }
        })

    }

    save() {
        const validation = this.check(this.form);
        if(validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `${this.mode == 'new'?'Add New':'Update'} Assessment for Member ${this.user.fullName} (${this.user.email})`,
                subMessage: 'Are you sure want to save this assessment?',
                buttonOkLabel: 'Yes, Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        dialog.componentInstance.result.subscribe(r => {
            if (r) {
                const payload = {
                    assessmentDate: isMoment(this.form.controls.assessmentDate.value)? this.date.momentToDbDate(this.form.controls.assessmentDate.value) : this.form.controls.assessmentDate.value,
                    competitionLevel: this.form.controls.competitionLevel.value,
                    userId: this.form.controls.userId.value,
                    summary: this.form.controls.summary.value,
                    individuals: this.scorecards,
                    wideMatches: this.wideMatch,
                    id: this.assessment.id
                }


                if(this.mode == 'new') {

                    payload['id'] = undefined;

                    this.scorecardService.save(payload).then(_ => {
                        this.form.reset();
                        this.form.markAsPristine();
                        this.form.markAsUntouched();
                        this.wideMatch = [];
                        this.scorecards = [];
                        this.showAlertDark('Assessment', '', 'Assessment has been added successfully');
                        this.router.navigate(['office/user/' + this.user.id+'/editor'], {queryParams: {'tab': 'scorecard'}}).then();
                    })
                } else {
                    this.scorecardService.update(payload).then(_ => {
                        this.form.reset();
                        this.form.markAsPristine();
                        this.form.markAsUntouched();
                        this.wideMatch = [];
                        this.scorecards = [];
                        this.showAlertDark('Assessment', '', 'Assessment has been updated successfully');
                        this.router.navigate(['office/user/' + this.user.id+'/editor'], {queryParams: {'tab': 'scorecard'}}).then();
                    })
                }


            }
        });
    }

    goBack() {
        this.router.navigate(['/office/user/' + this.user.id + '/editor'], {queryParams: {tab: 'scorecard'}}).then();
    }
}
